import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import { PrivateSEOHead } from 'components/SEOHead';
import Title from '../components/Title';
import TopAppBar from '../components/app-bar/TopAppBar';

import { CheckAuth } from '../components/CheckAuth';

const MainLayoutAuth = () => {
    return (
        <>
            <PrivateSEOHead title="Account Access" />
            <Title title="" />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    padding: 0,
                    margin: 0,
                    minHeight: '100vh',
                    // position: "relative",
                    w: '100%'
                    // background: "blue"
                }}
            >
                <Outlet />
            </Box>
        </>
    );
};

export default MainLayoutAuth;
